import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { BookingsApiKeysModel } from './models/bookings.api-keys';

@Component({
  selector   : 'bookings-api-secret-key',
  template: require('./bookings.api-secret-key.component.html')
})
export class BookingsApiSecretKeyComponent {
  @Input() keys : BookingsApiKeysModel;

  constructor (
    public activeModal     : NgbActiveModal,
    public translateService: TranslateService
  ) {}
}
